<script setup lang="ts">
withDefaults(defineProps<{
  icon: string;
  label: string;
  value: string;
  link?: string;
}>(), {
  link: undefined,
});
</script>

<template>
  <div class="info-field">
    <div class="d-flex align-center ga-1 mb-1">
      <v-icon
        :icon="icon"
        color="primary"
        size="x-small"
      />
      <span class="text-caption text-uppercase text-medium-emphasis info-field-label">
        {{ label }}
      </span>
    </div>
    <div class="text-body-1 font-weight-medium">
      <a
        v-if="link"
        :href="link"
        target="_blank"
        rel="noopener noreferrer"
        class="info-field-link"
      >
        {{ value }}
      </a>
      <template v-else>
        {{ value }}
      </template>
    </div>
  </div>
</template>

<style scoped>
.info-field {
  padding: 8px 0 8px 12px;
  border-left: 2px solid rgba(var(--v-theme-primary), .2);
}

.info-field-label {
  letter-spacing: .05em;
}

.info-field-link {
  color: inherit;
  text-decoration: none;
}
</style>
